import merge from 'lodash/merge';
import { combineReducers } from 'redux';
//import paginate from './paginate';
import inlinePaginate from './inline-paginate';
import localize from './localize';
import fetchStatus from './fetch-status';
import courses from '../modules/courses';
import events from '../modules/events';
import pros from '../modules/pros';
import search from '../modules/search';
import area from '../modules/common/components/areaselect/actions';

const initialState = {
  courses: {},
  events: {},
  pros: {},
};

// Updates an entity cache in response to any action with response.entities.
const entities = (state = initialState, action) => {
  if (action.response && action.response.entities) {
    return merge({}, state, action.response.entities);
  }

  return state;
};

// Updates the pagination data for different actions.
const pagination = combineReducers({
  coursesPaginated: inlinePaginate({
    types: [
      courses.actionTypes.FETCH_COURSES_REQUEST,
      courses.actionTypes.FETCH_COURSES_SUCCESS,
      courses.actionTypes.FETCH_COURSES_FAILURE,
      courses.actionTypes.NEXT_COURSES_PAGE,
      courses.actionTypes.RESET,
    ]
  }),
  eventsPaginated: inlinePaginate({
    types: [
      events.actionTypes.FETCH_EVENTS_REQUEST,
      events.actionTypes.FETCH_EVENTS_SUCCESS,
      events.actionTypes.FETCH_EVENTS_FAILURE,
      events.actionTypes.NEXT_EVENTS_PAGE,
      events.actionTypes.RESET,
    ]
  }),
  prosPaginated: inlinePaginate({
    types: [
      pros.actionTypes.FETCH_PROS_REQUEST,
      pros.actionTypes.FETCH_PROS_SUCCESS,
      pros.actionTypes.FETCH_PROS_FAILURE,
      pros.actionTypes.NEXT_PROS_PAGE,
      pros.actionTypes.RESET,
    ]
  }, true),
  searchPaginated: inlinePaginate({
    types: [
      search.actionTypes.FETCH_SEARCH_REQUEST,
      search.actionTypes.FETCH_SEARCH_SUCCESS,
      search.actionTypes.FETCH_SEARCH_FAILURE,
      search.actionTypes.NEXT_SEARCH_PAGE,
      search.actionTypes.RESET,
    ]
  })
});

const lastAction = (state = null, action) => {
  return action;
};

const rootReducer = combineReducers({
  entities,
  pagination,
  localize,
  fetchStatus,
  lastAction,
  [search.constants.NAME]: search.reducer,
  area,
})

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js